export enum Permission {
  ViewTests = 'Permission.CMS-SYSTEM-TESTS.View',
  ViewCategories = 'Permission.CMS-SYSTEM-CATEGORIES.View'
}
